export const CANCELBTN = "Cancel";
export const SEND_BTN = "Send";
export const EMAIL_MODAL_WIDTH = "40%";

// Duplicated subset of EMAIL_CANDIDATE_MODAL (owned by shared/ui/candidate).
export const EMAIL_CANDIDATE_MODAL_LABELS = Object.freeze({
  MESSAGE: "Message",
  MESSAGE_PLACEHOLDER: "Please enter message"
});
